import { render } from "./MentionLegal.vue?vue&type=template&id=42192b5e"
const script = {}

import "./MentionLegal.vue?vue&type=style&index=0&id=42192b5e&media=screen&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__